var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.068,
    height: 61.068,
    viewBox: "0 0 61.068 61.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48743",
    "data-name": "Group 48743",
    transform: "translate(11376 -13208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93291",
    "data-name": "Path 93291",
    d: "M39.69,55.261V27.78L62.12,41.52Z",
    transform: "translate(-11391.452 13197.185)",
    fill: "#047dd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93292",
    "data-name": "Path 93292",
    d: "M39.69,55.261,62.12,41.52,39.69,27.78Z",
    transform: "translate(-11391.452 13197.185)",
    fill: "#047dd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93293",
    "data-name": "Path 93293",
    d: "M30.534,0A30.534,30.534,0,1,0,61.068,30.534,30.534,30.534,0,0,0,30.534,0Zm0,56.794A26.259,26.259,0,1,1,56.794,30.534,26.259,26.259,0,0,1,30.534,56.794Z",
    transform: "translate(-11376 13208)",
    fill: "#047dd6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon2);
export default __webpack_public_path__ + "static/media/video_icon2.fb9778eefb83aceff4e86d9a5465fcc1.svg";
export { ForwardRef as ReactComponent };